export default __webpack_public_path__ + "static/media/success.d99b4a5a.png";